module.exports = __webpack_public_path__ + "static/media/29EUNOG13.d199c345.jpg";